var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeiboDesktopCollapse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 11,
  viewBox: "0 0 12 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 10.069a.68.68 0 0 1 .684-.676h10.115c.378 0 .684.3.684.676a.68.68 0 0 1-.684.675H.684A.68.68 0 0 1 0 10.07M5.09 2.6 2.724 4.627s-.761.338-1.013 0 0-.844 0-.844S5.089 0 5.765 0c.675 0 4.052 3.783 4.052 3.783s.254.506 0 .844c-.253.338-1.013 0-1.013 0L6.54 2.601l-.042 5.402s-.058.677-.733.677c-.676 0-.676-.677-.676-.677z"
})));
export default SvgWeiboDesktopCollapse;